export default {
  austenite: 'Austenit',
  general: 'Allgemeine Eigenschaften',
};
